import { onBeforeUnmount, ref } from 'vue';

const pdfProxyUrl = sourceUrl =>
  sourceUrl.replace(
    '/rails/active_storage/blobs/redirect/',
    '/rails/active_storage/blobs/proxy/'
  );

export const usePdfPreview = () => {
  const previewUrl = ref('');
  const isPreviewLoading = ref(false);
  const previewError = ref(false);
  let requestId = 0;

  const releasePreviewUrl = () => {
    if (!previewUrl.value) return;

    URL.revokeObjectURL(previewUrl.value);
    previewUrl.value = '';
  };

  const resetPdfPreview = () => {
    requestId += 1;
    isPreviewLoading.value = false;
    previewError.value = false;
    releasePreviewUrl();
  };

  const loadPdfPreview = async sourceUrl => {
    requestId += 1;
    const currentRequestId = requestId;
    isPreviewLoading.value = true;
    previewError.value = false;
    releasePreviewUrl();

    try {
      const response = await fetch(pdfProxyUrl(sourceUrl), {
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error('pdf_fetch_failed');

      const sourceBlob = await response.blob();
      const signature = await sourceBlob.slice(0, 1024).text();
      if (!signature.includes('%PDF-')) throw new Error('invalid_pdf');
      if (currentRequestId !== requestId) return;

      const pdfBlob = new Blob([sourceBlob], { type: 'application/pdf' });
      previewUrl.value = URL.createObjectURL(pdfBlob);
    } catch {
      if (currentRequestId === requestId) previewError.value = true;
    } finally {
      if (currentRequestId === requestId) isPreviewLoading.value = false;
    }
  };

  onBeforeUnmount(resetPdfPreview);

  return {
    previewUrl,
    isPreviewLoading,
    previewError,
    loadPdfPreview,
    resetPdfPreview,
  };
};
